import { render, staticRenderFns } from "./CategoriaCursos.vue?vue&type=template&id=303c5c08&scoped=true&lang=pug&"
import script from "./CategoriaCursos.vue?vue&type=script&lang=js&"
export * from "./CategoriaCursos.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaCursos.styl?vue&type=style&index=0&id=303c5c08&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303c5c08",
  null
  
)

export default component.exports